import React from 'react';
import { LiveChatData, ScreenType } from '../types';
import { getInfoMessage } from '../utils/language';

type MessageUnreadDividerProps = {
  chatData?: LiveChatData | null;
  screenType?: ScreenType;
};

const MessageUnreadDivider: React.FC<MessageUnreadDividerProps> = ({ chatData = null, screenType }) => {
  return (
    <div className="chatyme-message-item chatyme-unread-messages-border">
      <div className="chatyme-unread-messages-text">{getInfoMessage('unreadMessages', chatData, screenType)}</div>
    </div>
  );
};

export default MessageUnreadDivider;
